/**
 * Prints a branded ASCII art banner to the browser console.
 * Called once at app startup in main.tsx.
 */
export function printConsoleEasterEgg(): void {
    const ascii = `
  ██████╗  ███╗   ██╗  █████╗
 ██╔═══██╗ ████╗  ██║ ██╔══██╗
 ██║   ██║ ██╔██╗ ██║ ███████║
 ██║   ██║ ██║╚██╗██║ ██╔══██║
 ╚██████╔╝ ██║ ╚████║ ██║  ██║
  ╚═════╝  ╚═╝  ╚═══╝ ╚═╝  ╚═╝`;

    const font = "font-family: monospace;";
    const asciiStyle = `color: #6C8EEF; font-size: 12px; line-height: 1.2; ${font}`;
    const subtitle = `color: #8A8F98; font-size: 13px; ${font}`;
    const label = `color: #8A8F98; font-weight: bold; font-size: 13px; ${font}`;
    const link = `color: #6C8EEF; font-size: 13px; ${font}`;
    const support = `color: #8A8F98; font-size: 13px; ${font}`;

    console.log(
        `%c${ascii}\n%cAI software engineers for your team\n\n%cWE'RE HIRING:  %chttps://ona.com/careers\n%cDOCS:          %chttps://ona.com/docs\n%cCHANGELOG:     %chttps://ona.com/changelog\n\n%cFound a bug? Reach out to us via Pylon - you'll find it in the bottom-right floating icon.`,
        asciiStyle,
        subtitle,
        label,
        link,
        label,
        link,
        label,
        link,
        support,
    );
}
